import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EquityTokenForm from './EquityTokenForm';
import './EquityTokenForm.css';
import {
  getEquityTokenFormRequest,
  getTokenRequest,
  getTokenEditRequest,
  resetTokenForm,
  editTokenRequest,
  uploadImageRequest,
  uploadDocumentRequest,
} from '../../../redux/actions/tokenform';
import 'react-quill/dist/quill.snow.css';

EquityTokenForm.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

EquityTokenForm.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image', 'video'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

/*
 * PropType validation
 */
EquityTokenForm.propTypes = {
  placeholder: PropTypes.string,
};

const mapStateToProps = state => ({
  token: state.token.token.item,
  url: state.token.publicURL.url,
  docUrl: state.token.publicURL.docURL,
  legalForm: state.token.legalForm,
  // fieldType: state.token.publicURL.fieldType,
  formDocuments: state.token.formDocuments
});

const mapDispatchToProps = {
  getEquityTokenFormRequest,
  getTokenRequest,
  getTokenEditRequest,
  resetTokenForm,
  editTokenRequest,
  uploadImageRequest,
  uploadDocumentRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EquityTokenForm);
